import { type CarrierDef } from '../common.js'
import {
  accountNumber,
  apiKey,
  password,
  username,
  userPassMap,
} from '../internal.js'

// CRED NOTE - we collect these - but I don't see us using them anywhere (un/pw I understand could be for support, but why api key? )
const credentialTypes = [username, password, apiKey] as const
const locationCredentialTypes = [accountNumber] as const

export type pit1CredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const pit1: CarrierDef<pit1CredType> = {
  name: 'Pitt Ohio Supply Chain',
  scac: 'pit1',
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['account-number', 'ref1'],
  ],
  engineLayers: ['rating'],
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
